<template>
  <div class="hbspt-embed">
    <div v-show="!success" :id="`hbspt-embed-${formId}`"></div>
    <div v-if="success">
      <slot name="success"></slot>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.hbspt-embed
  ::v-deep
    fieldset
      max-width: none
    .hs-input
      @apply appearance-none p-4 rounded-lg text-black
    fieldset[class*=form-columns]
      &:not(.form-columns-1)
        @apply -mx-2
        .hs-form-field
          @apply px-2
      .hs-input
        &[type=text],
        &[type=email],
        &[type=tel]
          @apply w-full h-auto
      select,
      textarea
        @apply w-full
    .form-columns-2
      @apply flex flex-wrap
      > .hs-form-field
        @apply w-full
        @screen md
          @apply w-1/2
    .hs-form-checkbox-display,
    .hs-form-booleancheckbox-display,
    .hs-form-radio
      > span
        @apply ml-0
      .hs-input
        @apply hidden
        + span
          @apply inline-flex items-center
          &::before
            font-family: 'Material Icons'
            @apply leading-none text-2xl mr-4 align-middle
            font-feature-settings: 'liga' 1
            content: 'check_box_outline_blank'
        &:checked + span::before
          content: 'check_box'
    label
      @apply text-sm
      ~ .input
        @apply mt-2
    .hs-button
      @apply p-4 rounded-full w-64
</style>

<script>
export default {
  data() {
    return {
      success: false
    }
  },
  props: {
    formId: {
      type: String,
      required: true
    },
    portalId: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    addScript(src, cb, opts) {
      if (typeof document == "undefined") {
        return
      }
      if (!opts) {
        opts = {};
      }
      // TODO: don't add the same script more than once
      const script = document.createElement("script");
      script.src = src;
      if (opts.id) {
        script.id = opts.id;
      }
      if (opts.defer) {
        script.defer = opts.defer;
      }
      if (opts.async) {
        script.async = opts.async;
      }
      document.body.appendChild(script);
      script.addEventListener("load", cb);
    }
  },
  mounted() {
    const self = this;
    this.addScript("https://cdnjs.cloudflare.com/ajax/libs/jquery/3.1.1/jquery.min.js", () => {
      this.addScript("https://js.hsforms.net/forms/v2.js", () => {
        if(typeof window !== "undefined" && window.hbspt) {
          window.hbspt.forms.create({
            portalId: this.portalId,
            formId: this.formId,
            target: `#hbspt-embed-${this.formId}`,
            onFormReady: function($form) {
              $form[0].className="hs-form hs-form-private";
            },
            onFormSubmit: function($form) {
              self.$emit("sendData", $form);
            },
            onFormSubmitted: function($form) {
              self.success = true;
              self.$emit("submit");
            }
          });
        };
      }, { id: "hs-forms-v2" });
    }, { id: "jquery-1311" });
  }
}
</script>
